import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { equalisations as rules } from 'further-ui/validations';
import { z } from 'zod';

export type AddCommitmentsToEqualisationFormValues = z.infer<
  typeof rules.AddCommitmentsToEqualisationFormSchema
>;

type Props = {
  values: AddCommitmentsToEqualisationFormValues;
  children: React.ReactNode;
  isEditingApprovedClose?: boolean;
};

const FormWrapper: React.FC<Props> = ({
  children,
  values,
  isEditingApprovedClose,
}) => {
  const schema = rules.getAddCommitmentsToEqualisationFormSchema(
    isEditingApprovedClose,
  );
  const formMethods = useForm<AddCommitmentsToEqualisationFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(schema),
    defaultValues: values,
    criteriaMode: 'all',
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
